import { useEffect, useState } from "react";
import GenerateImages from "./Photos/generate-images";
import GenerateDescTitle from "./TitleAndDesc/generate-desc-title";
import MarketingAssests from "./MarketingAssests/marketing-assests";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import StartUploading from "../Comp-enhance-AIlisting/start-uploading/start-uploading";

const Url = process.env.REACT_APP_URl;


const ListingCreation: React.FunctionComponent<{}> = (props) => {


    const [activeTab, setActiveTab] = useState<string>(sessionStorage.getItem('taps') || "Photos");
    const [listingValue, setListingValue] = useState<any>(() => {
        const storedListing = sessionStorage.getItem("listing");
        return storedListing ? JSON.parse(storedListing) : null;
    });
    const [isChangeState, setIsChangeState] = useState<boolean>(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const [isUploaded, setIsUploaded] = useState<boolean>(sessionStorage.getItem("listing") ? true : false);
    const [isOversized, setIsOversized] = useState<boolean>(false);
    const [isUpgradeMsg, setIsUpgradeMsg] = useState<boolean>(false);
    const [msgUpgrade, setMsgUpgrade] = useState<string>();
    const { t } = useTranslation();
    const features = [
        {
            img: <img src="/assets/images/Enhance Low Light.png" alt="Enhance Low Light" />,
            label: t("enhancementList.enhanceLowLight")
        },
        {
            img: <img src="/assets/images/Image Super Resolution.png" alt="Image Super Resolution" />,
            label: t("enhancementList.Image Super Resolution")
        },
        {
            img: <img src="/assets/images/Sky Replacement.png" alt="Sky Replacement" />,
            label: t("enhancementList.skyReplacement")
        },
        {
            img: <img src="/assets/images/Resize Image.png" alt="Resize Image" />,
            label: t("enhancementList.Resize Image")
        },
        {
            img: <img src="/assets/images/Resize Image.png" alt="Remove Object" />,
            label: t("enhancementList.Remove Object")
        },
        {
            img: <img src="/assets/images/Blur People Faces.png" alt="Blur People Faces" />,
            label: t("enhancementList.Blur People Faces")
        },
        {
            img: <img src="/assets/images/Blur Car plates.png" alt="Blur Car plates" />,
            label: t("enhancementList.Blur Car plates")
        },
        {
            img: <img src="/assets/images/Compress Image.png" alt="Compress Image" />,
            label: t("enhancementList.Compress Image")
        }
    ];
    const aiFeatures = [
        {
            img: <img src="/assets/images/3D Floor plan.png" alt="3D Floor plan" />,
            label: t("enhancementList.3D Floor plan")
        },
        {
            img: <img src="/assets/images/Room Staging.png" alt="Room Staging" />,
            label: t("enhancementList.Room Staging")
        },
        {
            img: <img src="/assets/images/Room Remodeling.png" alt="Room Remodeling" />,
            label: t("enhancementList.Room Remodeling")
        },
        {
            img: <img src="/assets/images/Style Transfer.png" alt="Style Transfer" />,
            label: t("enhancementList.Style Transfer")
        }
    ];
    const dataUpload = {
        title: t("startUploading.title"),
        description: t("startUploading.subtitle"),
        features: features,
        aiFeatures: aiFeatures
    }

    useEffect(() => {
        setIsChangeState(false)
        setListingValue(sessionStorage.getItem("listing") ? sessionStorage.getItem("listing") : "")
    }, [isChangeState])


    const ChangeTapsHandler = (value: any) => {
        setActiveTab(value);
        sessionStorage.setItem('taps', value)
    };

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };


    const ChangeMessageHandler = (msg: string, value: boolean, color: string) => {
        setColorSnackbar(color)
        setOpenSnackbar(true)
        setMessage(msg)
        setIsChangeState(!isChangeState)
    }

    const UploadImagesHandler = async (newValue: any, value: boolean) => {
        setIsOversized(value)
        setActiveTab("Photos")
        setListingValue(newValue);
        sessionStorage.setItem("processid", newValue.processid);
        sessionStorage.setItem("listing", JSON.stringify(newValue));
        setIsUploaded(true);
    };

    const ShowMessageUpgradeHandler = (msg: any) => {
        setMsgUpgrade(msg)
        setIsUpgradeMsg(true)
    }


    return (
        <div className="container-xxl flex-grow-1 marg-bottom-50">
            <div className="row d-flex justify-content-center align-items-center mt-2 mb-4">
                <div className="tabs padd-10 gap-30">
                    <button disabled={activeTab === "MarketingAssests"}
                        className={`tab color-08 title-onest-18 para-16-mb cursor-p ${activeTab === "Photos" ? "tab-active" : ""}`}
                        // onClick={() => setActiveTab("Photos")}
                    >
                        {t('listingCreation.photos')}
                    </button>
                    <button disabled={activeTab === "MarketingAssests"}
                        className={`tab color-08 title-onest-18 para-16-mb cursor-p ${activeTab === "TitleAndDescription" ? "tab-active" : ""} `}
                        // onClick={() => setActiveTab("TitleAndDescription")}
                    >
                        {t('listingCreation.descriptionTitle')}
                    </button>
                    <button
                        className={`tab  color-08 title-onest-18 para-16-mb ${activeTab === "MarketingAssests" ? "tab-active" : ""}`}
                    >
                        {t('propertiesPage.publish')}
                    </button>
                </div>
            </div>

            {activeTab === "Photos" ?
                isUploaded ?
                    <GenerateImages onChangeTaps={ChangeTapsHandler} onChangeMessagehandler={ChangeMessageHandler} onShowMessageUpgrade={ShowMessageUpgradeHandler} listingValue={sessionStorage.getItem("listing")} isOversized={isOversized} />
                    :
                    <StartUploading OnUploadImages={UploadImagesHandler} onChangeTaps={(value :string) => setActiveTab(value)} onShowMessageUpgrade={ShowMessageUpgradeHandler} onChangehandler={ChangeMessageHandler} data={dataUpload} />
                : (activeTab === "TitleAndDescription" ?
                    <GenerateDescTitle onChangeTaps={ChangeTapsHandler} onShowMessageUpgrade={ShowMessageUpgradeHandler} onChangehandler={ChangeMessageHandler} />
                    : <MarketingAssests onChangeTaps={ChangeTapsHandler} onChangehandler={ChangeMessageHandler} />)}


            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar} autoHideDuration={10000}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

            <Dialog
                open={isUpgradeMsg}
                onClose={() => setIsUpgradeMsg(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title" className="title-20 color-000000 d-flex align-items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="#746AFF"
                        viewBox="0 0 24 24"
                    >
                        <path d="M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm1 17h-2v-2h2zm0-4h-2V7h2z" />
                    </svg>
                    {t('listingCreation.upgradeRequired')}
                </DialogTitle>

                <DialogContent>
                    <p className="title-18 bold-400 line-height-30 color-000000" style={{ marginBottom: 0 }}>
                        {msgUpgrade}
                    </p>
                </DialogContent>
                <DialogActions>
                    <button
                        type="button"
                        className="button-dash padd-15-30 border-trans border-746AFF color-746AFF"
                        onClick={() => setIsUpgradeMsg(false)}
                    >
                        {t('propertiesPage.close')}
                    </button>
                    <a
                        className="button-dash padd-15-30 border-trans back-746AFF color-FFFFFF"
                        href="https://join-agents.coraly.ai/" target="_blank" rel="noopener noreferrer"
                    >
                        Upgrade Now
                    </a>
                </DialogActions>
            </Dialog>

        </div >
    )
}

export default ListingCreation;